// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import axios from 'axios' //引入axios依赖
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios);
Vue.prototype.$axios = axios //引入axios依赖之后并全局注册

import http from './assets/js/utils/request' //axios实例化后引入取名http
Vue.prototype.http = http //放入全局

//解决NavigationDuplicated 报错
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//解决路由跳转更换title
router.beforeEach((to, from, next) => {
    if(to.meta.title){
     document.title = to.meta.title
    }
    next();    
 })
//  router.beforeEach((to, from, next) => {
//     if(to.meta.title){
//         document.title = to.meta.title
//     }
//     if (navigator.geolocation) {
//         // 获取位置
//         navigator.geolocation.getCurrentPosition(showPosition, showError);
//     } else {
//         alert("您的浏览器不支持地理定位");
//     }
    
//   });
//    // 显示位置
//    function showPosition(position) {
//     const latitude = position.coords.latitude;  // 纬度
//     const longitude = position.coords.longitude;  // 经度
//     const accuracy = position.coords.accuracy;  // 精度
//     let str = `
//         纬度: ${latitude}<br>
//         经度: ${longitude}<br>
//         精度: ${accuracy} 米
//     `
// }

// // 错误处理
// function showError(error) {
//     switch(error.code) {
//         case error.PERMISSION_DENIED:
//             alert("用户拒绝了位置请求");
//             break;
//         case error.POSITION_UNAVAILABLE:
//             alert("无法获取当前位置");
//             break;
//         case error.TIMEOUT:
//             alert("请求超时");
//             break;
//         case error.UNKNOWN_ERROR:
//             alert("发生未知错误");
//             break;
//     }
// }
//引入element-ui
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI, { size: 'middle' })

//解决IE浏览器ES6的问题（IE浏览器打开项目空白页问题）
import 'babel-polyfill';

//main全局引入公共less文件（不要问我为什么这样写）
// import '!style-loader!css-loader!less-loader!./assets/less/tablePublic.less'
import '../src/assets/less/public.less'

//安装iview（vue中使用baidu-map获取当前坐标）
import iView from 'iview'
import 'iview/dist/styles/iview.css'
Vue.use(iView)

// 引入echarts
// import echarts from 'echarts'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import 'echarts-gl';

// 引入导出
import htmlToPdf from '@/assets/js/utils/htmlToPdf'
Vue.prototype.$htmlToPdf = htmlToPdf


//引入jQuery
import jquery from 'jquery'
Vue.prototype.$ = jquery

//按钮权限
import { hasPermission } from '../src/assets/js/common/hasPermission'
Vue.prototype.hasPerm = hasPermission

//在vue项目中解决Chrome控制台non-passive event listener输出问题
import 'default-passive-events'

// 添加监听事件
Vue.prototype.resetSetItem = (key, newVal) => {
    if (key === 'websocketHistory') {
        // 创建一个StorageEvent事件
        let newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: (k, val) => {
                localStorage.setItem(k, val);
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
                // 派发对象
                window.dispatchEvent(newStorageEvent);
            }
        };
        return storage.setItem(key, newVal);
    }
}

// import socket from '../src/assets/js/common/mysocket'
// Vue.prototype.sendMsg = socket.sendMsg


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js